import { Injectable } from '@angular/core';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { DataService } from 'src/app/shared/session';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegionOficinaService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private saveRegionOficinaUrl: string = 'regionOficina/save';
  private listarRegionOficinaPorUrl: string = 'regionOficina/listarPor';

  guardarRegionOficina(idRegion: number, idOficina: number): any {
    let parameters: string;
    parameters = JSON.stringify({
      idRegion: idRegion,
      idOficina: idOficina,
    });
    this.dataService.set(this.saveRegionOficinaUrl);
    return this.dataService.execPostJson(parameters);
  }

  listarRegionOficina(filtro: string, idRegion: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    parameters = parameters.append("idRegion", String(idRegion));
    this.dataService.set(this.listarRegionOficinaPorUrl);
    return this.dataService.execGetJson(parameters);
  }
}
